<template>
    <section class="page-title" :style="style">
        <div class="title-content">
            <div class="container">
                <h2 v-text="title"></h2>
            </div>
        </div>
        <scroll-indicator></scroll-indicator>
    </section>
</template>
<script>
    import ScrollIndicator from './../components/ScrollIndicator'

    export default {
        props: ['background', 'title'],
        components: {
            ScrollIndicator
        },
        computed: {
            style() {
                if( ! this.background ) return false

                return {
                    backgroundImage: 'url('+this.background+')',
                }
            }
        }
    }
</script>